import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M21.75 18c0 .74-.447 1.329-.987 1.757-.548.434-1.294.791-2.15 1.077-1.721.574-4.055.916-6.613.916s-4.892-.342-6.612-.916c-.857-.286-1.603-.643-2.15-1.077-.54-.428-.988-1.016-.988-1.757V6.504A2.2 2.2 0 0 1 2 5.5C2 3.015 6.477 1 12 1s10 2.015 10 4.5q-.002.518-.25 1.004zM18.456 7.314C20.17 6.542 20.5 5.784 20.5 5.5s-.329-1.042-2.044-1.814C16.88 2.977 14.6 2.5 12 2.5s-4.88.477-6.456 1.186C3.83 4.458 3.5 5.216 3.5 5.5s.329 1.042 2.044 1.814C7.12 8.023 9.4 8.5 12 8.5s4.88-.477 6.456-1.186m1.794.73C18.448 9.225 15.425 10 12 10s-6.448-.775-8.25-1.956V12c0 .09.053.291.419.581.359.285.925.574 1.694.83 1.529.51 3.695.839 6.137.839s4.608-.328 6.137-.839c.769-.256 1.335-.545 1.694-.83.366-.29.419-.492.419-.581zm-16.5 6.064V18c0 .09.053.291.419.581.359.285.925.573 1.694.83 1.529.51 3.695.839 6.137.839s4.608-.328 6.137-.839c.769-.257 1.335-.545 1.694-.83.366-.29.419-.492.419-.581v-3.892a8.4 8.4 0 0 1-1.637.726c-1.721.574-4.055.916-6.613.916s-4.892-.342-6.612-.916a8.4 8.4 0 0 1-1.638-.726",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }